<template>
  <div>
    <div v-if="isRedirectPage">
      <RedirectPage />
    </div>
    <div v-else>
      <Header />
      <div>
        <router-view :key="$route.fullPath"></router-view>
      </div>
      <Footer />
    </div>
    
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import Footer from "../Footer/Footer.vue";
import Header from "../Header/Header.vue";
import RedirectPage from "../RedirectPage/RedirectPage.vue";
export default defineComponent({
  components: {
    Footer,
    Header,
    RedirectPage,
  },
  computed: {
    isRedirectPage(): boolean {
      return this.$route.path.toLowerCase().includes("/redirectpage");
    }
  },
  mounted(){
    this.clearBlogSearchOnPageChange();
    this.clearForumFilter();
  },
  watch: {
    $route:{
      immediate: true,
      handler(){
       this.clearBlogSearchOnPageChange();
       this.clearForumFilter();
      }
    },
  },
  methods:{
    clearBlogSearchOnPageChange(){
      if (!this.$route.path.includes('/blog') && !this.$route.path.includes('/article')) {
         localStorage.removeItem("searchQuery");
       }
    },
    clearForumFilter(){
      if(!this.$route.path.includes('/forum')){
      this.$store.dispatch("ForumFilter", null);
      this.$store.state.isSearch = '';
      }
    }
  }
});
</script>
